
export default function ChatContainer(props) {
    return (
        <div className="ChatContainer">
            { props.children }
        </div>
    )
}